import type { UseQueryOptions } from "@tanstack/vue-query";
import { useQuery } from "@tanstack/vue-query";
import { computed, type Ref, unref } from "vue";
import profileService from "@/services/profile";
import type { ResolvedImpersonation } from "./types";

export const getQueryKey = (token: string | undefined) => ["resolveImpersonation", token];

interface Args<TData = ResolvedImpersonation> {
  token: Ref<string | undefined>;
  useQueryOptions?: Partial<UseQueryOptions<ResolvedImpersonation, Error, TData>>;
}

export const useResolveImpersonation = <TData = ResolvedImpersonation>({ token, useQueryOptions }: Args<TData>) => {
  return useQuery<ResolvedImpersonation, Error, TData>({
    queryKey: computed(() => getQueryKey(unref(token))),
    queryFn: () => profileService.resolveImpersonation(),
    ...useQueryOptions,
  });
};
